// extracted by mini-css-extract-plugin
export default {"wrapper":"EmailConfirmation_wrapper--Biq","container":"EmailConfirmation_container--mit","info":"EmailConfirmation_info--_5T","chatContainer":"EmailConfirmation_chatContainer--rJ1"};